import { ChannelTypes } from '../../../home/types/ChannelTypes';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { IRelatedContentInfo } from '../../../ts/models/resourceInfoParts';
import { ValidTelemetryEvent } from '../../../commonInfra/services/Telemetry';
import { TelemetryEvents } from '../TelemetryEvents';

export enum ContentLocation {
  Home = 'HOME',
  Explore = 'EXPLORE',
  SpaceHeader = 'SPACE_HEADER'
}

export enum FavoriteToggleType {
  Favorite = 'FAVORITE',
  Unfavorite = 'UNFAVORITE'
}

export enum ExploreDisplayMode {
  List = 'LIST',
  Grid = 'GRID'
}

export interface ContentTelemetryCommonData {
  readonly contentId: string;
  readonly contentType: ExplorableItemType;
  readonly contentLocation: ContentLocation;
  readonly space: string;
  readonly subspace: string;
  readonly contentPosition: number;
}

interface ContentTelemetryHomeData {
  homeChannel: ChannelTypes;
}

interface ContentTelemetryExploreData {
  displayMode: ExploreDisplayMode;
  contentTotal: number;
}

interface ContentTelemetrySearchData {
  searchTerm: string;
}

interface ContentTelemetryRecommendationData {
  recommendationsMetadata: string;
}

type ContentTelemetryRelatedData = IRelatedContentInfo;

export type ContentTelemetryContextSpecificData = ContentTelemetryHomeData |
                                                  ContentTelemetryExploreData |
                                                  ContentTelemetrySearchData |
                                                  ContentTelemetryRecommendationData |
                                                  ContentTelemetryRelatedData;

export function isHomeData(data: ContentTelemetryContextSpecificData): data is ContentTelemetryHomeData {
  return (<ContentTelemetryHomeData>data).homeChannel !== undefined;
}

export function isExploreData(data: ContentTelemetryContextSpecificData): data is ContentTelemetryExploreData {
  return (<ContentTelemetryExploreData>data).displayMode !== undefined &&
    (<ContentTelemetryExploreData>data).contentTotal !== undefined;
}

export function isSearchData(data: ContentTelemetryContextSpecificData): data is ContentTelemetrySearchData {
  return (<ContentTelemetrySearchData>data).searchTerm !== undefined;
}

export interface ContentClickedEvent extends
ValidTelemetryEvent<ContentClickedEvent>,
ContentTelemetryCommonData,
Partial<ContentTelemetryHomeData>,
Partial<ContentTelemetryExploreData>,
Partial<ContentTelemetrySearchData>,
Partial<ContentTelemetryRecommendationData> {
  readonly type: TelemetryEvents.ContentClicked;
}
export interface FavoriteToggleClickedEvent extends
ValidTelemetryEvent<FavoriteToggleClickedEvent>,
ContentTelemetryCommonData,
Partial<ContentTelemetryHomeData>,
Partial<ContentTelemetryExploreData>,
Partial<ContentTelemetrySearchData>,
Partial<ContentTelemetryRecommendationData> {
  readonly type: TelemetryEvents.FavoriteToggleClicked;
  readonly toggleType: FavoriteToggleType;
}
export interface ActionMenuItemClickedEvent extends
ValidTelemetryEvent<ActionMenuItemClickedEvent>,
ContentTelemetryCommonData,
Partial<ContentTelemetryHomeData>,
Partial<ContentTelemetryExploreData>,
Partial<ContentTelemetrySearchData>,
Partial<ContentTelemetryRecommendationData> {
  readonly type: TelemetryEvents.ActionMenuItemClicked;
  readonly actionType: string;
}

export type ContentClickedEventHandler = () => void;
export type FavoriteToggleClickedEventHandler = (toggleType: FavoriteToggleType) => void;
export type ActionMenuItemClickedEventHandler = (actionType: string) => void;

export type ContentTelemetryEventHandlers =  ContentClickedEventHandler | FavoriteToggleClickedEventHandler | ActionMenuItemClickedEventHandler;
